<template>
    <v-row>
		<v-col cols="6" class="pt-2" style="background-color: #eaf4ed42">
			<!-- offer -->
			<v-row v-if="$route.query.type === 'offer'" class="mt-2">
				<v-col :cols="isBlackPepper ? 12 : 12" class="py-0">
					<v-row dense class="ma-0 mb-2">
						<!-- type -->
						<v-col v-if="!isBlackPepper" :sm="!isBlackPepper ? 6 : 4" cols="12">
							<v-autocomplete
								v-model.number="offerData.isSeed"
								:label="$T('inputs.type')"
								:items="[
									{ id: 1, name: 'Cardamom', value: false },
									{ id: 2, name: 'Seeds', value: true }
								]"
								item-text="name"
								item-value="value"
								hide-spin-buttons
								dense
								outlined
								hide-details
								:rules="rules.requiredAsNumber"
								readonly
								:loading="loadingSectionOne"
							></v-autocomplete>
						</v-col>
						
						<!-- date -->
						<v-col :sm="!isBlackPepper ? 6 : 4" cols="12">
							<bee-date-picker
								v-model="offerData.date"
								:label="$T('inputs.date')"
								dense
								outlined
								hide-details
								menu-picker
								:input-props="{ readonly: true, dense: true, outlined: true }"
								:rules="rules.required"
								readonly
								:loading="loadingSectionOne"
							></bee-date-picker>
						</v-col>

						<!-- provider -->
						<v-col :sm="!isBlackPepper ? 6 : 4" cols="12">
							<v-autocomplete
								v-model="offerData.providerId"
								:items="providers"
								item-text="name"
								item-value="id"
								:label="$T('inputs.provider')"
								dense
								outlined
								hide-details
								:rules="rules.required"
								readonly
								:loading="loadingSectionOne"
							></v-autocomplete>
						</v-col>
						
						<!-- no -->
						<v-col :sm="!isBlackPepper ? 6 : 2" cols="12">
							<v-text-field
								v-model.number="offerData.entryNo"
								:label="$T('inputs.entry-no')"
								type="number"
								min="0"
								hide-spin-buttons
								dense
								outlined
								hide-details
								:rules="rules.requiredAsNumber"
								readonly
								:loading="loadingSectionOne"
							></v-text-field>
						</v-col>
						
						<!-- density -->
						<v-col :sm="!isBlackPepper ? 6 : 2" cols="12">
							<v-text-field
								v-model.number="offerData.density"
								:label="$T('inputs.density')"
								type="number"
								min="0"
								hide-spin-buttons
								dense
								outlined
								hide-details
								:rules="rules.requiredAsNumber"
								readonly
								:loading="loadingSectionOne"
							></v-text-field>
						</v-col>
						<div v-if="isBlackPepper" style="width: 100%" class="d-flex flex-wrap">
							<v-col style="width: 20%" class="pa-1">
								<v-text-field
									v-model="offerData.grande"
									:label="$T('inputs.large') + ' (%)'"
									type="number"
									min="0"
									hide-spin-buttons
									dense
									outlined
									hide-details
									readonly
									:loading="loadingSectionOne"
								/>
							</v-col>

							<v-col   style="width: 20%" class="pa-1">
								<v-text-field
									v-model="offerData.mediano"
									:label="$T('inputs.medium') + ' (%)'"
									type="number"
									min="0"
									hide-spin-buttons
									dense
									outlined
									hide-details
									readonly
									:loading="loadingSectionOne"
								/>
							</v-col>

							<v-col  style="width: 20%" class="pa-1">
								<v-text-field
									v-model="offerData.pequeño"
									:label="$T('inputs.little') + ' (%)'"
									type="number"
									min="0"
									hide-spin-buttons
									dense
									outlined
									hide-details
									readonly
									:loading="loadingSectionOne"
								/>
							</v-col>
							<v-col  style="width: 20%" class="pa-1">
								<v-text-field
									v-model="offerData.con_Collila"
									:label="$T('inputs.con-collila') + ' (%)'"
									type="number"
									min="0"
									hide-spin-buttons
									dense
									outlined
									hide-details
									readonly
									:loading="loadingSectionOne"
								/>
							</v-col>
							<v-col  style="width: 20%" class="pa-1">
								<v-text-field
									v-model="offerData.maduro"
									:label="$T('inputs.mature') + ' (%)'"
									type="number"
									min="0"
									hide-spin-buttons
									dense
									outlined
									hide-details
									readonly
									:loading="loadingSectionOne"
								/>
							</v-col>
						</div>

						<div v-if="isBlackPepper" style="width: 100%" class="d-flex flex-wrap">
							<v-col  style="width: 20%" class="pa-1">
								<v-text-field
									v-model="offerData.quebrado"
									:label="$T('inputs.broken') + ' (%)'"
									type="number"
									min="0"
									hide-spin-buttons
									dense
									outlined
									hide-details
									readonly
									:loading="loadingSectionOne"
								/>
							</v-col>
							<v-col  style="width: 20%" class="pa-1">
								<v-text-field
									v-model="offerData.mohoso"
									:label="$T('inputs.moldy') + ' (%)'"
									type="number"
									min="0"
									hide-spin-buttons
									dense
									outlined
									hide-details
									readonly
									:loading="loadingSectionOne"
								/>
							</v-col>
							<v-col  style="width: 20%" class="pa-1">
								<v-text-field
									v-model="offerData.hojos"
									:label="$T('inputs.leaves') + ' (%)'"
									type="number"
									min="0"
									hide-spin-buttons
									dense
									outlined
									hide-details
									readonly
									:loading="loadingSectionOne"
								/>
							</v-col>
							<v-col  style="width: 20%" class="pa-1">
								<v-text-field
									v-model="offerData.colpila"
									:label="$T('inputs.colpila') + ' (%)'"
									type="number"
									min="0"
									hide-spin-buttons
									dense
									outlined
									hide-details
									readonly
									:loading="loadingSectionOne"
								/>
							</v-col>

							<v-col  style="width: 20%" class="pa-1">
								<v-text-field
									v-model="offerData.verde"
									:label="$T('inputs.verde') + ' (%)'"
									type="number"
									min="0"
									hide-spin-buttons
									dense
									outlined
									hide-details
									readonly
									:loading="loadingSectionOne"
								/>
							</v-col>
						</div>
					</v-row>

					<!-- purchase Item sub-tree -->
					<v-row v-if="0" dense class="mb-0">
						<v-col md="6" sm="8" cols="12">
							<v-autocomplete
								v-model="purchaseSubTreeItemId"
								:label="$T('inputs.item-to-purchase-from')"
								:items="itemsTree"
								item-text="name"
								item-value="id"
								hide-details
								dense
								outlined
								readonly
								:loading="loadingSectionOne"
								@change="updateOfferEntires"
							></v-autocomplete>
						</v-col>
					</v-row>
				</v-col>

				<v-col :cols="isBlackPepper ? 12 : 12" class="py-0">
					<!-- table -->
					<template v-if="!offerData.isSeed">
						<bee-handy-smart-table
							v-model="tableInputs"
							ref="entiresTable"
							:headers="offerHeader"
							:items="!loadingSectionOne ? offerData.entires : []"
							:items-per-page="-1"
							fixed-header
							:height="$vuetify.breakpoint.height - 235"
							dense
							hot-inputs
							hide-default-footer
							hide-inputs-details
							:data-table-props="{
								disableSort: true,
								noDataText: $T('messages.select-Item-to-purchase')
							}"
							:loading="loadingSectionOne"
						>
							<!-- item name -->
							<template v-slot:item.itemName="{ item }">
								{{item.itemName}}
								<span v-if="item.parentName" class="ms-1 text-caption grey--text">
									({{item.parentName}})
								</span>
							</template>

							<!-- actions -->
							<template v-slot:item.actions="{ item, index }">
								<v-btn
									v-if="item.isNotDefault"
									icon
									@click="offerData.entires.splice(index, 1)"
									color="alert-color"
								>
									<v-icon>$delete</v-icon>
								</v-btn>
							</template>

							<!-- foot -->
							<template v-if="0" v-slot:foot>
								<tr>
									<td class="custom-foot-row px-2"></td>
									<td class="custom-foot-row px-2"></td>
									<td class="custom-foot-row px-2 text-end">
										<v-btn
											text
											class="px-1"
											color="grey darken-4"
											@click="showAddRow = !showAddRow"
										>
											<v-icon class="me-2">$add</v-icon>
											<span v-if="!showAddRow">{{$T('add')}} {{$T('headers.item')}}</span>
											<span v-else>{{$T('close')}}</span>
										</v-btn>
									</td>
								</tr>
							</template>
						</bee-handy-smart-table>

						<v-divider class="mt-3 mb-2"/>
						<div class="d-flex text-body-1 font-weight-bold primary--text">
							<div class="px-2" style="width: 120px">
								Total
							</div>
							<v-spacer/>
							<div
								:class="{'red--text': totalPercentForOffer !== 100}"
								class="ps-2"
								style="width: 30%"
							>
								{{totalPercentForOffer}}%
								<v-icon v-if="totalPercentForOffer !== 100" color="red">$alert</v-icon>
							</div>
							<v-btn
								class="px-2"
								color="grey white--text"
								:to="{ name: $route.query.type === 'offer' ? 'purchases' : 'receiving' }"
								small
							>
							<v-icon size="20" class="me-1">$back</v-icon>
							{{$T('back')}}
						</v-btn>
						</div>
					</template>

				</v-col>
			</v-row>

			<!-- receiving / purchase -->
			<v-row v-if="$route.query.type !== 'offer'">
				<!-- table -->
				<v-col cols="8" class="mt-2 pb-0">
					<!-- table -->
					<bee-handy-smart-table
						id="dialogTable"
						ref="entiresTable"
						:headers="purchaseHeader"
						:items="purchaseData.entires.filter(c => (!purchaseData.isSeed && c.itemCategory === itemCategory.commercial) ? true : (c.id === seedsId && c.itemCategory === itemCategory.commercial))"
						:items-per-page="-1"
						fixed-header
						:height="$vuetify.breakpoint.height - 80"
						dense
						hot-inputs
						hide-default-footer
						hide-inputs-details
						:item-class="item => item.parentId ? 'grey lighten-4' : null"
						:data-table-props="{
							disableSort: true,
							noDataText: $t('messages.select-Item-to-purchase')
						}"
						:loading="loadingSectionOne"
					>
						<template v-slot:item.itemName="{ item }">
							<span :class="{'ms-6': item.parentId}">
								{{item.itemName}}
							</span>
						</template>

						<template v-slot:item.weight="{ item }">
							{{$options.filters.numberFormat(fixNumber(item.weight))}} 
							<span v-if="item.parentId">
								/ {{$options.filters.numberFormat(fixNumber(getParentWeight(item.parentId)))}}
							</span>
			
						</template>

						<!-- percent -->
						<template
							v-if="!$route.query.receivingId || isAdmin"
							v-slot:item.percent="{ item }"
						>
							<div class="d-flex justify-center">
								<v-text-field
									v-model.number="item.percent"
									type="number"
									min="0"
									hide-spin-buttons
									dense
									hide-details
									class="mb-4"
									:error="
										item.parentId
											? getTotalChildrenPercent(purchaseData.entires, item.parentId) !== 100
											: !item.parentId ? getTotalParentPercent(purchaseData.entires) !== 100 : false 
									"
									:rules="rules.requiredAsPercent"
									@input="updateItemsWeights"
									style="height: 17px !important"
									readonly
								/>
								<span
									v-if="item.hasChildren"
									class="text-caption ms-6"
									:class="{'alert-color--text': getTotalChildrenPercent(purchaseData.entires, item.id) !== 100}"
								>
									({{getTotalChildrenPercent(purchaseData.entires, item.id)}}%)
								</span>
							</div>
						</template>
					</bee-handy-smart-table>
				</v-col>
				
				<v-col cols="4" class="mt-2 pb-0" align-self="start">
					<v-row class="rounded mb-2 mt-1" >
						<!-- lot -->
						<v-col  cols="12" class="p-1 py-1">
							<v-text-field
								v-model.number="purchaseData.lot"
								:label="$T('inputs.lot')"
								type="number"
								min="0"
								hide-spin-buttons
								dense
								outlined
								readonly
								:loading="loadingSectionOne"
								hide-details
								:rules="rules.requiredAsNumber"
							/>
						</v-col>
					
						<!-- date -->
						<v-col  cols="12" class="p-1 py-1">
							<v-text-field
								v-model="purchaseData.date"
								:label="$T('inputs.date')"
								dense
								outlined
								hide-details
								readonly
								:loading="loadingSectionOne"
								:rules="rules.required"
							></v-text-field>
						</v-col>
					
						<!-- income -->
						<v-col  cols="12" class="p-1 py-1">
							<v-text-field
								v-model.number="purchaseData.income"
								:label="$T('inputs.entry-no')"
								type="number"
								min="0"
								hide-spin-buttons
								dense
								outlined
								readonly
								:loading="loadingSectionOne"
								hide-details
							/>
						</v-col>
					
						<!-- provider -->
						<v-col  cols="12" class="p-1 py-1">
							<!-- receiveItem.status === receiveStatus.received ? accounts : providers -->
							<v-autocomplete
								v-model="purchaseData.providerId"
								:items="[]"
								item-text="name"
								item-value="id"
								:label="$T('inputs.provider')"
								dense
								outlined
								readonly
								:loading="loadingSectionOne"
								hide-details
								:rules="rules.required"
							/>
						</v-col>
					
						<!-- qq-net-weight -->
						<v-col  cols="12" class="p-1 py-1">
							<v-text-field
								v-model="purchaseData.weightFormat"
								v-number-format.number="[purchaseData.weightFormat, purchaseData.weight]"
								:label="$T('inputs.weight')"
								dense
								outlined
								hide-details
								:rules="rules.required"
								@change="updateItemsWeights"
								readonly
								:loading="loadingSectionOne"
							/>
						</v-col>
					
						<!-- price -->
						<v-col  cols="12" class="p-1 py-1">
							<v-text-field
								v-model="purchaseData.priceFormat"
								:label="$T('inputs.price')"
								dense
								outlined
								hide-details
								:rules="rules.required"
								@change="purchaseData.totalPurchase = purchaseData.weight * purchaseData.price"
								v-number-format.number="[purchaseData.priceFormat, purchaseData.price]"
								readonly
								:loading="loadingSectionOne"
							/>
						</v-col>

						<v-col cols="12" class="p-1 py-1">
							<v-text-field 
								v-model.number="purchaseData.humidity"
								:label="$T('inputs.humidity') + ' (%)'"
								dense
								outlined
								hide-details
								readonly
								:loading="loadingSectionOne"
							/>
						</v-col>
						<!-- total-price -->
						<v-col cols="12" class="p-1 py-1">
							<v-text-field		
								:label="$T('inputs.total-price')"
								dense
								outlined
								readonly
								:loading="loadingSectionOne"
								hide-details
								:value="purchaseData.totalPurchase ? $options.filters.numberFormat(fixNumber(purchaseData.totalPurchase)) : 0"
							/>
						</v-col>
					</v-row>

					<v-row>
						<!-- special-invoice -->
						<v-col sm="12" cols="12" class="p-1 py-1">
							<v-text-field
								v-model="purchaseData.specialInvoice"
								:label="$T('inputs.special-invoice')"
								dense
								outlined
								hide-details
								readonly
								:loading="loadingSectionOne"
							></v-text-field>
						</v-col>
				
						<!-- credit-note -->
						<v-col sm="12" cols="12" class="p-1 py-1">
							<v-text-field
								v-model="purchaseData.creditNote"
								:label="$T('inputs.credit-note')"
								dense
								outlined
								hide-details
								readonly
								:loading="loadingSectionOne"
							></v-text-field>
						</v-col>
						
						<!-- paco-reference -->
						<v-col sm="12" cols="12" class="p-1 py-1">
							<v-text-field
								v-model="purchaseData.pacoReference"
								:label="$T('inputs.paco-reference')"
								dense
								outlined
								hide-details
								readonly
								:loading="loadingSectionOne"
							></v-text-field>
						</v-col>
				
						<!-- notes -->
						<v-col cols="12" class="p-1 py-1">
							<v-textarea
								v-model="purchaseData.notes"
								:label="$T('inputs.notes')"
								dense
								outlined
								hide-details
								rows="1"
								no-resize
								auto-grow
								readonly
								:loading="loadingSectionOne"
							></v-textarea>
						</v-col>

						<v-divider class="mt-3 mb-2"/>
						<div class="d-flex text-body-1 font-weight-bold primary--text">
							<div class="px-2" style="">
								Total
							</div>
							<v-spacer/>
							<v-spacer/>
							<div
								:class="{'red--text': getTotalParentPercent(purchaseData.entires) !== 100}"
								class="ps-2"
								style=""
							>
								({{getTotalParentPercent(purchaseData.entires)}}%)
								<v-icon
									v-if="getTotalParentPercent(purchaseData.entires) !== 100"
									color="red"
								>
									$alert
								</v-icon>
							</div>
						</div>
					</v-row>
				</v-col>
			</v-row>
			
			<v-row v-if="$route.query.type !== 'offer'" justify="end" class="py-0 mt-0">
				<v-col class="py-0 d-flex justify-end" cols="12">
					<v-btn
						class="px-2"
						color="grey white--text"
						:to="{ name: $route.query.type === 'offer' ? 'purchases' : 'receiving' }"
						small
					>
						<v-icon size="20" class="me-1">$back</v-icon>
						{{$T('back')}}
					</v-btn>
				</v-col>
			</v-row>
			
		</v-col>

		<v-divider vertical />

		<v-col cols="6" id="section-two" :class="isChoose ? 'pt-2 bgGreenLight' : '' ">
			<template v-if="!isChoose">
				<v-tabs
					v-model="selectedOption"
                    background-color="#eaf4ed"
					@change="needToReset = true; filter()"
				>
					<v-tab
						:disabled="loading"
						class="text-capitalize"
					>
						{{$T('ComparePage.offer')}}
					</v-tab>

					<v-tab
						:disabled="loading"
						class="text-capitalize"
					>
						{{$T('ComparePage.purchases')}}
					</v-tab>
				</v-tabs>

				<v-divider class="mb-2" />

				<bee-handy-table
					ref="table"
					:headers="headers"
					:items="[]"
					:items-per-page="20"
					fixed-header
					:height="$vuetify.breakpoint.height - 140"
					dense
					pagination-on-scroll
					pagination-on-scroll-server-items
					:server-items-length="totalItems"
					:options-scroll.sync="scrollOptions"
					shown-rows-text
					:loading="loading"
					:data-table-props="{ disableSort: true }"
					@pagination-on-scroll:reach-last-row="filter"
					zebra
				>
					<template v-slot:item.action="{ item }">
						<v-btn
							color="preview-color"
							icon
							size="small"
							@click="
								isChoose = true; 
								loadingSectionTwo = true; 
								getById(item.id, selectedOption, item.purchaseId ? item.purchaseId : null, loadingSectionTwo)
							"
						>
							<v-icon>
								mdi-check
							</v-icon>
						</v-btn>
					</template>
				</bee-handy-table>
			</template>

			<template v-else>
				<div v-if="!$route.query.typeSectionTwo" class="loading-overlay d-flex justify-center align-center" style="width: 100%; height: 100%">
					<v-progress-circular indeterminate color="primary"></v-progress-circular>
				</div>
				<v-row v-if="$route.query.typeSectionTwo === 'offer'" class="mt-2">
					<v-col cols="12" class="py-0">
						<v-row dense class="ma-0 mb-2">
							<!-- type -->
							<v-col v-if="!isBlackPepper" :sm="!isBlackPepper ? 6 : 4" cols="12">
								<v-autocomplete
									v-model.number="offerDataCompareTwo.isSeed"
									:label="$T('inputs.type')"
									:items="[
										{ id: 1, name: 'Cardamom', value: false },
										{ id: 2, name: 'Seeds', value: true }
									]"
									item-text="name"
									item-value="value"
									hide-spin-buttons
									dense
									outlined
									hide-details
									:rules="rules.requiredAsNumber"
									readonly
									:loading="loadingSectionTwo"
								></v-autocomplete>
							</v-col>
							
							<!-- date -->
							<v-col :sm="!isBlackPepper ? 6 : 4" cols="12">
								<bee-date-picker
									v-model="offerDataCompareTwo.date"
									:label="$T('inputs.date')"
									dense
									outlined
									hide-details
									menu-picker
									:input-props="{ readonly: true, dense: true, outlined: true }"
									:rules="rules.required"
									readonly
									:loading="loadingSectionTwo"
								></bee-date-picker>
							</v-col>

							<!-- provider -->
							<v-col :sm="!isBlackPepper ? 6 : 4" cols="12">
								<v-autocomplete
									v-model="offerDataCompareTwo.providerId"
									:items="providers"
									item-text="name"
									item-value="id"
									:label="$T('inputs.provider')"
									dense
									outlined
									hide-details
									:rules="rules.required"
									readonly
									:loading="loadingSectionTwo"
								></v-autocomplete>
							</v-col>
							
							<!-- no -->
							<v-col :sm="!isBlackPepper ? 6 : 2" cols="12">
								<v-text-field
									v-model.number="offerDataCompareTwo.entryNo"
									:label="$T('inputs.entry-no')"
									type="number"
									min="0"
									hide-spin-buttons
									dense
									outlined
									hide-details
									:rules="rules.requiredAsNumber"
									readonly
									:loading="loadingSectionTwo"
								></v-text-field>
							</v-col>
							
							<!-- density -->
							<v-col :sm="!isBlackPepper ? 6 : 2" cols="12">
								<v-text-field
									v-model.number="offerDataCompareTwo.density"
									:label="$T('inputs.density')"
									type="number"
									min="0"
									hide-spin-buttons
									dense
									outlined
									hide-details
									:rules="rules.requiredAsNumber"
									readonly
									:loading="loadingSectionTwo"
								></v-text-field>
							</v-col>
							<div v-if="isBlackPepper" style="width: 100%" class="d-flex flex-wrap">
								<v-col  style="20%" class="pa-1">
									<v-text-field
										v-model="offerDataCompareTwo.grande"
										:label="$T('inputs.large') + ' (%)'"
										type="number"
										min="0"
										hide-spin-buttons
										dense
										outlined
										hide-details
										readonly
										:loading="loadingSectionTwo"
									/>
								</v-col>

								<v-col  style="20%" class="pa-1">
									<v-text-field
										v-model="offerDataCompareTwo.mediano"
										:label="$T('inputs.medium') + ' (%)'"
										type="number"
										min="0"
										hide-spin-buttons
										dense
										outlined
										hide-details
										readonly
										:loading="loadingSectionTwo"
									/>
								</v-col>

								<v-col  style="20%" class="pa-1">
									<v-text-field
										v-model="offerDataCompareTwo.pequeño"
										:label="$T('inputs.little') + ' (%)'"
										type="number"
										min="0"
										hide-spin-buttons
										dense
										outlined
										hide-details
										readonly
										:loading="loadingSectionTwo"
									/>
								</v-col>
								<v-col  style="20%" class="pa-1">
									<v-text-field
										v-model="offerDataCompareTwo.con_Collila"
										:label="$T('inputs.con-collila') + ' (%)'"
										type="number"
										min="0"
										hide-spin-buttons
										dense
										outlined
										hide-details
										readonly
										:loading="loadingSectionTwo"
									/>
								</v-col>
								<v-col  style="20%" class="pa-1">
									<v-text-field
										v-model="offerDataCompareTwo.maduro"
										:label="$T('inputs.mature') + ' (%)'"
										type="number"
										min="0"
										hide-spin-buttons
										dense
										outlined
										hide-details
										readonly
										:loading="loadingSectionTwo"
									/>
								</v-col>
							</div>
							<div v-if="isBlackPepper" style="width: 100%" class="d-flex flex-wrap">
								<v-col  style="20%" class="pa-1">
									<v-text-field
										v-model="offerDataCompareTwo.quebrado"
										:label="$T('inputs.broken') + ' (%)'"
										type="number"
										min="0"
										hide-spin-buttons
										dense
										outlined
										hide-details
										readonly
										:loading="loadingSectionTwo"
									/>
								</v-col>
								<v-col  style="20%" class="pa-1">
									<v-text-field
										v-model="offerDataCompareTwo.mohoso"
										:label="$T('inputs.moldy') + ' (%)'"
										type="number"
										min="0"
										hide-spin-buttons
										dense
										outlined
										hide-details
										readonly
										:loading="loadingSectionTwo"
									/>
								</v-col>
								<v-col  style="20%" class="pa-1">
									<v-text-field
										v-model="offerDataCompareTwo.hojos"
										:label="$T('inputs.leaves') + ' (%)'"
										type="number"
										min="0"
										hide-spin-buttons
										dense
										outlined
										hide-details
										readonly
										:loading="loadingSectionTwo"
									/>
								</v-col>
								<v-col  style="20%" class="pa-1">
									<v-text-field
										v-model="offerDataCompareTwo.colpila"
										:label="$T('inputs.colpila') + ' (%)'"
										type="number"
										min="0"
										hide-spin-buttons
										dense
										outlined
										hide-details
										readonly
										:loading="loadingSectionTwo"
									/>
								</v-col>

								<v-col  style="20%" class="pa-1">
									<v-text-field
										v-model="offerDataCompareTwo.verde"
										:label="$T('inputs.verde') + ' (%)'"
										type="number"
										min="0"
										hide-spin-buttons
										dense
										outlined
										hide-details
										readonly
										:loading="loadingSectionTwo"
									/>
								</v-col>
							</div>
						</v-row>

						<!-- purchase Item sub-tree -->
						<v-row v-if="0" dense class="mb-0">
							<v-col md="6" sm="8" cols="12">
								<v-autocomplete
									v-model="purchaseSubTreeItemId"
									:label="$T('inputs.item-to-purchase-from')"
									:items="itemsTree"
									item-text="name"
									item-value="id"
									hide-details
									dense
									outlined
									readonly
									:loading="loadingSectionTwo"
									@change="updateOfferEntires"
								></v-autocomplete>
							</v-col>
						</v-row>
					</v-col>

					<v-col cols="12" class="py-0">
						<!-- table -->
						<template v-if="!offerDataCompareTwo.isSeed">
							<bee-handy-smart-table
								v-model="tableInputsCompareTwo"
								ref="entiresTableCompareTwo"
								:headers="offerHeaderTwoSection"
								:items="!loadingSectionTwo ? offerDataCompareTwo.entires : []"
								:items-per-page="-1"
								fixed-header
								:height="$vuetify.breakpoint.height - 235"
								dense
								hot-inputs
								hide-default-footer
								hide-inputs-details
								:data-table-props="{
									disableSort: true,
									noDataText: $T('messages.select-Item-to-purchase')
								}"
								:loading="loadingSectionTwo"
							>
								<!-- item name -->
								<template v-slot:item.itemName="{ item }">
									{{item.itemName}}
									<span v-if="item.parentName" class="ms-1 text-caption grey--text">
										({{item.parentName}})
									</span>
								</template>

								<!-- actions -->
								<template v-slot:item.actions="{ item, index }">
									<v-btn
										v-if="item.isNotDefault"
										icon
										@click="offerDataCompareTwo.entires.splice(index, 1)"
										color="alert-color"
									>
										<v-icon>$delete</v-icon>
									</v-btn>
								</template>

								<!-- foot -->
								<template v-if="0" v-slot:foot>
									<tr>
										<td class="custom-foot-row px-2"></td>
										<td class="custom-foot-row px-2"></td>
										<td class="custom-foot-row px-2 text-end">
											<v-btn
												text
												class="p-1"
												color="grey darken-4"
												@click="showAddRow = !showAddRow"
											>
												<v-icon class="me-2">$add</v-icon>
												<span v-if="!showAddRow">{{$T('add')}} {{$T('headers.item')}}</span>
												<span v-else>{{$T('close')}}</span>
											</v-btn>
										</td>
									</tr>
								</template>
							</bee-handy-smart-table>

							<v-divider class="mt-3 mb-2"/>
							<div class="d-flex text-body-1 font-weight-bold primary--text">
								<div class="px-2" style="width: 120px">
									Total
								</div>
								<v-spacer/>
								<div
									:class="{'red--text': totalPercentForOffer !== 100}"
									class="ps-2"
									style="width: 30%"
								>
									{{totalPercentForOffer}}%
									<v-icon v-if="totalPercentForOffer !== 100" color="red">$alert</v-icon>
								</div>
							</div>
						</template>
					</v-col>
				</v-row>

				<v-row v-if="$route.query.typeSectionTwo === 'purchase'" class="">
					<!-- table -->
					<v-col cols="8" class="mt-2">
						<!-- table -->
						<bee-handy-smart-table
							id="dialogTable"
							ref="entiresTable"
							:headers="purchaseHeaderTwoSection"
							:items="purchaseDataCompareTwo.entires.filter(c => (!purchaseDataCompareTwo.isSeed && c.itemCategory === itemCategory.commercial) ? true : (c.id === seedsId && c.itemCategory === itemCategory.commercial))"
							:items-per-page="-1"
							fixed-header
							:height="$vuetify.breakpoint.height - 80"
							dense
							hot-inputs
							hide-default-footer
							hide-inputs-details
							:item-class="item => item.parentId ? 'grey lighten-4' : null"
							:data-table-props="{
								disableSort: true,
								noDataText: $t('messages.select-Item-to-purchase')
							}"
							:loading="loadingSectionTwo"
						>
							<template v-slot:item.itemName="{ item }">
								<span :class="{'ms-6': item.parentId}">
									{{item.itemName}}
								</span>
							</template>

							<template v-slot:item.weight="{ item }">
								{{$options.filters.numberFormat(fixNumber(item.weight))}} 
								<span v-if="item.parentId">
									/ {{$options.filters.numberFormat(fixNumber(getParentWeight(item.parentId)))}}
								</span>
				
							</template>

							<!-- percent -->
							<template
								v-if="!$route.query.receivingId || isAdmin"
								v-slot:item.percent="{ item }"
							>
								<div class="d-flex justify-center">
									<v-text-field
										v-model.number="item.percent"
										type="number"
										min="0"
										hide-spin-buttons
										dense
										hide-details
										class="mb-4"
										:error="
											item.parentId
												? getTotalChildrenPercent(purchaseDataCompareTwo.entires, item.parentId) !== 100
												: !item.parentId ? getTotalParentPercent(purchaseDataCompareTwo.entires) !== 100 : false 
										"
										:rules="rules.requiredAsPercent"
										@input="updateItemsWeights"
										style="height: 17px !important"
										readonly
									/>
									<span
										v-if="item.hasChildren"
										class="text-caption ms-6"
										:class="{'alert-color--text': getTotalChildrenPercent(purchaseDataCompareTwo.entires, item.id) !== 100}"
									>
										({{getTotalChildrenPercent(purchaseDataCompareTwo.entires, item.id)}}%)
									</span>
								</div>
							</template>
						</bee-handy-smart-table>
					</v-col>
					
					<v-col cols="4" class="mt-2" align-self="start">
						<v-row class="rounded mb-2 mt-1">
							<!-- lot -->
							<v-col  cols="12" class="px-1 py-1">
								<v-text-field
									v-model.number="purchaseDataCompareTwo.lot"
									:label="$T('inputs.lot')"
									type="number"
									min="0"
									hide-spin-buttons
									dense
									outlined
									readonly
									hide-details
									:rules="rules.requiredAsNumber"
									:loading="loadingSectionTwo"
								/>
							</v-col>
						
							<!-- date -->
							<v-col  cols="12" class="px-1 py-1">
								<v-text-field
									v-model="purchaseDataCompareTwo.date"
									:label="$T('inputs.date')"
									dense
									outlined
									hide-details
									readonly
									:rules="rules.required"
									:loading="loadingSectionTwo"
								></v-text-field>
							</v-col>
						
							<!-- income -->
							<v-col  cols="12" class="px-1 py-1">
								<v-text-field
									v-model.number="purchaseDataCompareTwo.income"
									:label="$T('inputs.entry-no')"
									type="number"
									min="0"
									hide-spin-buttons
									dense
									outlined
									readonly
									:loading="loadingSectionTwo"
									hide-details
								/>
							</v-col>
						
							<!-- provider -->
							<v-col  cols="12" class="px-1 py-1">
								<!-- receiveItem.status === receiveStatus.received ? accounts : providers -->
								<v-autocomplete
									v-model="purchaseDataCompareTwo.providerId"
									:items="accounts"
									item-text="name"
									item-value="id"
									:label="$T('inputs.provider')"
									dense
									outlined
									readonly
									:loading="loadingSectionTwo"
									hide-details
									:rules="rules.required"
								/>
							</v-col>
						
							<!-- qq-net-weight -->
							<v-col  cols="12" class="px-1 py-1">
								<v-text-field
									v-model="purchaseDataCompareTwo.weightFormat"
									v-number-format.number="[purchaseData.weightFormat, purchaseData.weight]"
									:label="$T('inputs.weight')"
									dense
									outlined
									hide-details
									:rules="rules.required"
									@change="updateItemsWeights"
									readonly
									:loading="loadingSectionTwo"
								/>
							</v-col>
						
							<!-- price -->
							<v-col cols="12" class="px-1 py-1">
								<v-text-field
									v-model="purchaseDataCompareTwo.priceFormat"
									:label="$T('inputs.price')"
									dense
									outlined
									hide-details
									:rules="rules.required"
									@change="purchaseData.totalPurchase = purchaseData.weight * purchaseData.price"
									v-number-format.number="[purchaseData.priceFormat, purchaseData.price]"
									readonly
									:loading="loadingSectionTwo"
								/>
							</v-col>

							<v-col cols="12" class="px-1 py-1">
								<v-text-field 
									v-model.number="purchaseDataCompareTwo.humidity"
									:label="$T('inputs.humidity') + ' (%)'"
									dense
									outlined
									hide-details
									readonly
									:loading="loadingSectionTwo"
								/>
							</v-col>
							<!-- total-price -->
							<v-col cols="12" class="px-1 py-1">
								<v-text-field		
									:label="$T('inputs.total-price')"
									dense
									outlined
									readonly
									:loading="loadingSectionTwo"
									hide-details
									:value="purchaseDataCompareTwo.totalPurchase ? $options.filters.numberFormat(fixNumber(purchaseDataCompareTwo.totalPurchase)) : 0"
								/>
							</v-col>
						</v-row>

						<v-row>
							<!-- special-invoice -->
							<v-col sm="12" cols="12" class="px-1 py-1">
								<v-text-field
									v-model="purchaseDataCompareTwo.specialInvoice"
									:label="$T('inputs.special-invoice')"
									dense
									outlined
									hide-details
									readonly
									:loading="loadingSectionTwo"
								></v-text-field>
							</v-col>
					
							<!-- credit-note -->
							<v-col sm="12" cols="12" class="px-1 py-1">
								<v-text-field
									v-model="purchaseDataCompareTwo.creditNote"
									:label="$T('inputs.credit-note')"
									dense
									outlined
									hide-details
									readonly
									:loading="loadingSectionTwo"
								></v-text-field>
							</v-col>
							
							<!-- paco-reference -->
							<v-col sm="12" cols="12" class="px-1 py-1">
								<v-text-field
									v-model="purchaseDataCompareTwo.pacoReference"
									:label="$T('inputs.paco-reference')"
									dense
									outlined
									hide-details
									readonly
									:loading="loadingSectionTwo"
								></v-text-field>
							</v-col>
					
							<!-- notes -->
							<v-col cols="12" class="px-1 py-1">
								<v-textarea
									v-model="purchaseDataCompareTwo.notes"
									:label="$T('inputs.notes')"
									dense
									outlined
									hide-details
									rows="1"
									no-resize
									auto-grow
									readonly
									:loading="loadingSectionTwo"
								></v-textarea>
							</v-col>

							<v-divider class="mt-3 mb-2"/>
							<div class="d-flex text-body-1 font-weight-bold primary--text">
								<div class="px-2" style="">
									Total
								</div>
								<v-spacer/>
								<v-spacer/>
								<div
									:class="{'red--text': getTotalParentPercent(purchaseDataCompareTwo.entires) !== 100}"
									class="ps-2"
									style=""
								>
									({{getTotalParentPercent(purchaseDataCompareTwo.entires)}}%)
									<v-icon
										v-if="getTotalParentPercent(purchaseDataCompareTwo.entires) !== 100"
										color="red"
									>
										$alert
									</v-icon>
								</div>
							</div>
						</v-row>
					</v-col>
				</v-row>
			</template>

			<v-btn
				v-if="isChoose"
				small
				@click="closeCompare()"
				color="primary"
				class="my-1"
				style="position: fixed; bottom: 0px; right: 16px"
			>	
				<v-icon small>
					mdi-close 
				</v-icon>
				{{ $T('close') }}
			</v-btn>
		</v-col>
    </v-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { isBlackPepper } from '@/global.config'
import moment from 'moment'
import rules from '@/helpers/validation-rules'
import { fixNumber } from '@/helpers/functions'
import { itemCategory, receiveStatus } from '@/helpers/enums'

export default ({
	data () {
		return {
			rules,
			isBlackPepper,
			itemCategory,
			receiveStatus,

			selectedOption: 0,
			items: [],

			// offer
			offerData: {
				date: moment().format('YYYY-MM-DD'),
				providerId: null,
				entryNo: null,
				density: null,
				isSeed: false,

				entires: [],
				// for black pepper 
				hojos: 0,
				colpila: 0,
				grande: 0,
				maduro: 0,
				mohoso: 0,
				quebrado: 0,
				pequeño: 0,
				mediano: 0,
				con_Collila: 0,
				verde: 0
			},
			tableInputs: {},

			loadingWeightedAverages: false,
			purchaseSubTreeItemId: null,
			totalItems: 0,

			loading: false,
			scrollOptions: {},
			needToReset: false,

			// compare two
			offerDataCompareTwo: {
				date: moment().format('YYYY-MM-DD'),
				providerId: null,
				entryNo: null,
				density: null,
				isSeed: false,

				entires: [],
				// for black pepper 
				hojos: 0,
				colpila: 0,
				grande: 0,
				maduro: 0,
				mohoso: 0,
				quebrado: 0,
				pequeño: 0,
				mediano: 0,
				con_Collila: 0,
				verde: 0
			},
			tableInputsCompareTwo: {},

			// loadingWeightedAverages: false,
			// purchaseSubTreeItemId: null,
			// totalItems: 0,

			// loading: false,
			// scrollOptions: {},
			// needToReset: false,
			// // // // //

			// purchases
			purchaseData: {
				lot: null,
				date: null,
				income: null,
				providerId: null,
				weight: null,
				price: null,
				totalPurchase: null,

				specialInvoice: null,
				creditNote: null,
				pacoReference: null,
				notes: null,
				isSeed: false,

				entires: [],
				priceFormat: null,	
				weightFormat: null,
				humidity: 0
			},

			purchaseDataCompareTwo: {
				lot: null,
				date: null,
				income: null,
				providerId: null,
				weight: null,
				price: null,
				totalPurchase: null,

				specialInvoice: null,
				creditNote: null,
				pacoReference: null,
				notes: null,
				isSeed: false,

				entires: [],
				priceFormat: null,	
				weightFormat: null,
				humidity: 0
			},

			loadingPurchase: false,
			receiveItem: {},

			isChoose: false,

			loadingSectionOne: false,

			loadingSectionTwo: false
		}
	},

	computed: {
		...mapState({
			itemsTree: state => state.items.itemsTree,
			providers: state => state.configs.configsTrees.providers,
			cardamomRootId: state => state.configs.itemsConfigs.cardamomRootId,
			seedsId: state => state.configs.itemsConfigs.seedsId,
			accounts: state => state.accounts.accounts.filter(c => !c.isArchived)
		}),

		...mapGetters({
			getAccountById: 'accounts/getAccountById'
		}),
		
		headers () {
			return [
				{
					text: this.$T('headers.entry-no'),
					name: 'entryNo',
					value: +this.selectedOption === 0 ? 'entryNo' : 'income',
				},
				{
					text: this.$T('headers.date'),
					name: 'date',
					value: 'date',
					type: 'date',
					dateFormat: 'YYYY-MM-DD',
				},
				{
					text: this.$T('headers.provider'),
					name: 'providerId',
					value: 'providerId',
					noNotAvailableText: true,
					setValueExpr: val => val ? this.getAccountById(val)?.name : 'Ugarit'
				},
				{
					text: '',
					name: 'action',
					value: 'action'
				}
			]
		},

		offerHeader () {
			return [
				{
					text: this.$T('headers.item'),
					name: 'itemName',
					value: 'itemName',
					columnClass: 'px-2',
				},
				{
					text: this.$t('headers.average-percentages-of-previous-purchases') + ' %',
					name: 'weightedAveragePercentage',
					value: 'weightedAveragePercentage',
					setValueExpr: val => this.fixNumber(val),
					noNotAvailableText: true,
					cellClass: 'grey--text text-center',
					align: 'center'
				},
				{
					text: '%',
					name: 'percent',
					value: 'percent',
					class: 'text-h6',
					columnClass: 'px-2',
					type: 'number',
					inputRules: rules.requiredAsPercent,
					width: '30%'
					// writable: true
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					width: 0,
					columnClass: 'px-0',
					noNotAvailableText: true,
					sortable: false,
					noInput: true,
				},
			]
		},

		offerHeaderTwoSection () {
			return [
				{
					text: this.$T('headers.item'),
					name: 'itemName',
					value: 'itemName',
					columnClass: 'px-2',
				},
				{
					text: this.$t('headers.average-percentages-of-previous-purchases') + ' %',
					name: 'weightedAveragePercentage',
					value: 'weightedAveragePercentage',
					setValueExpr: val => this.fixNumber(val),
					noNotAvailableText: true,
					cellClass: 'grey--text text-center',
					align: 'center'
				},
				{
					text: '%',
					name: 'percent',
					value: 'percent',
					class: 'text-h6',
					columnClass: 'px-2',
					type: 'number',
					inputRules: rules.requiredAsPercent,
					width: '30%'
					// writable: true
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					width: 0,
					columnClass: 'px-0',
					noNotAvailableText: true,
					sortable: false,
					noInput: true,
				},
			]
		},

		purchaseHeader () {
			return [
				{
					text: this.$T('headers.item'),
					name: 'itemName',
					value: 'itemName',
					columnClass: 'px-2',
				},
				{
					text: this.$T('headers.weight'),
					name: 'weight',
					value: 'weight',
					columnClass: 'px-2',
					align: 'center',
					type: 'number-format',
					width: 180,
					noNotAvailableText: true,
				},
				{
					text: '%',
					name: 'percent',
					value: 'percent',
					class: 'text-h6',
					columnClass: 'px-2',
					type: 'number',
					inputRules: rules.requiredAsPercent,
				}
			]
		},

		purchaseHeaderTwoSection () {
			return [
				{
					text: this.$T('headers.item'),
					name: 'itemName',
					value: 'itemName',
					columnClass: 'px-2',
				},
				{
					text: this.$T('headers.weight'),
					name: 'weight',
					value: 'weight',
					columnClass: 'px-2',
					align: 'center',
					type: 'number-format',
					width: 180,
					noNotAvailableText: true,
				},
				{
					text: '%',
					name: 'percent',
					value: 'percent',
					class: 'text-h6',
					columnClass: 'px-2',
					type: 'number',
					inputRules: rules.requiredAsPercent,
				}
			]
		},

		totalPercentForOffer() {
			const offerData = !this.isChoose ? this.offerData : this.offerDataCompareTwo
			return offerData.entires.map(c => c.percent).reduce((a, b) => +a + b, 0)
		},
	},

	methods: {
		moment,
		fixNumber,
		
		closeCompare () {
			this.isChoose = false;	
			this.resetQuery(['typeSectionTwo', 'sectionTwoId', 'purchaseTwoSectionId']);
			this.filter()
		},

		resetQuery(paramsToReset) {
			const newQuery = { ...this.$route.query };
			paramsToReset.forEach((param) => {
				delete newQuery[param];
			});
			this.$router.push({ query: newQuery }).catch(() => {});
		},

		updateOfferEntires() {
			const offerData = !this.isChoose ? this.offerData : this.offerDataCompareTwo
			offerData.entires = [];
			this.purchaseSubTreeItemId = this.cardamomRootId || this.items[0]?.id;
			if (!this.purchaseSubTreeItemId) return;
			const subTree = this.itemsTree.find(c => c.id === this.purchaseSubTreeItemId);

			subTree.children.filter(c => c.itemCategory === itemCategory.commercial).forEach(c => {
				offerData.entires.push({
					id: c.id,
					itemName: c.name,
					parentName: null,
					percent: 0,
					weightedAveragePercentage: 0
				})
			})
		},

		getWeightedAveragesByProvider (id) {
			const offerData = !this.isChoose ? this.offerData : this.offerDataCompareTwo
			if (offerData.isSeed === false) {
				this.loadingWeightedAverages = true
				return this.$store.dispatch('purchases/getWeightedAveragesByProvider', { providerId: id }).then((data) => {
					offerData.entires.forEach((entry, index) => {
						const item = data.find(c => c.itemId === entry.id);
						offerData.entires[index].weightedAveragePercentage = item ? item.weightedAveragePercentage : 0;
					})
				}).then(() => {
					this.loadingWeightedAverages = false
				}).catch(() => {
					this.loadingWeightedAverages = false
				})
			}
		},

		// purchase 
		getParentWeight(id) {
			const purchaseData = !this.isChoose ? this.purchaseData : this.purchaseDataCompareTwo
			const item = purchaseData.entires.find(c => c.id === id);
			if (item) return item.weight;
		},

		updateItemsWeights(val) {
			if (val) {
				const purchaseData = !this.isChoose ? this.purchaseData : this.purchaseDataCompareTwo
				purchaseData.totalPurchase = purchaseData.weight * purchaseData.price;
				for (let i = 0; i < purchaseData.entires.length; i++) {
					const entry = purchaseData.entires[i];
					const weight =
						entry.parentId ? this.getParentWeight(entry.parentId) : purchaseData.weight

					purchaseData.entires[i].weight =
						fixNumber((purchaseData.entires[i].percent / 100) * weight);
				}
			}
		},

		getTotalParentPercent(entries) {
			return entries.filter(c => c.parentId === null).reduce((res, a) => res + +a.percent, 0)
		},

		updatePurchaseEntires () {
			const purchaseData = !this.isChoose ? this.purchaseData : this.purchaseDataCompareTwo
			purchaseData.entires = [];
			const purchaseSubTreeItemId = this.cardamomRootId || this.itemsTree[0].id;
			if (!purchaseSubTreeItemId) return;
			const subTree = this.itemsTree.find(c => c.id === purchaseSubTreeItemId);

			subTree.children.forEach(c => {
				purchaseData.entires.push({
					id: c.id,
					itemName: c.name,
					parentName: null,
					parentId: null,
					hasChildren: Boolean(c.children && c.children.length > 0),
					weight: 0,
					percent: 0,
					itemCategory: c.itemCategory
				})
				if (!c.children.length) return;

				c.children.forEach(e => {
					purchaseData.entires.push({
						id: e.id,
						itemName: e.name,
						parentName: c.name,
						parentId: e.parentId,
						hasChildren: false,
						weight: 0,
						percent: 0,
						itemCategory: c.itemCategory
					})
				})
			})
		},

		getTotalChildrenPercent(entries, parentId) {
			return entries.filter(c => c.parentId === parentId).reduce((res, a) => res + +a.percent, 0);
		},
		
		// shared
		filter (newScrollOptions) {
			console.log('newScrollOptions')
			if (this.$refs.table && this.needToReset === true) {
				this.$refs.table.resetShownRows()
			}
			let page = 1;
			if (newScrollOptions) {
				page = newScrollOptions.page
			} else if (this.$refs.table) {
				this.$refs.table.resetShownRows()
			}
			const itemsPerPage = this.scrollOptions.itemsPerPage;
			
			this.loading = true;
			const moduleName = +this.selectedOption === 0 ? 'purchases' : 'receives'
			return this.$store.dispatch(`${moduleName}/fetchAll`, {
				page: page,
				perPage: itemsPerPage || 20,
			}).then(({ data, total }) => {
				console.log(total)
				this.totalItems = total;
				this.$refs.table.addScrollItems(data);
			}).finally(() => {
				this.loading = false;
			})
		},

		getById (id, type, purchaseId, loading) {			
			if (type === 0) this.updateOfferEntires()

			const request = type === 0 ? 'purchases/fetchById' : 'receives/fetchById'

			return this.$store.dispatch(request, { id: id }).then(res => {
				if (type === 0) {
					const offerById = res
					const offerData = !this.isChoose ? this.offerData : this.offerDataCompareTwo

					offerData.date = moment(offerById.date).format('YYYY-MM-DD')
					offerData.providerId = offerById.providerId;
					offerData.entryNo = offerById.entryNo;
					offerData.density = offerById.density;
					offerData.isSeed = offerById.isSeed;
					const removeIndexes = [];
	
					if (offerData.isSeed === false) { 
						this.getWeightedAveragesByProvider(offerById.providerId).finally(() => {
							offerData.entires.forEach((entry, index) => {
								const item = offerById.items.find(c => c.itemId === entry.id);
								if (item) {
									offerData.entires[index].percent = item.percent;
								} else if (this.isPreview) {
									removeIndexes.push(index);
								}
							})
						})
					}
	
					removeIndexes.forEach(index => { offerData.entires[index] = {} });
					offerData.entires = offerData.entires.filter(c => Object.keys(c).length);
	
					offerData.hojos = offerById.hojos || null;
					offerData.colpila = offerById.colpila || null;
					offerData.grande = offerById.grande || null;
					offerData.maduro = offerById.maduro || null;
					offerData.mohoso = offerById.mohoso || null;
					offerData.quebrado = offerById.quebrado || null;
					offerData.pequeño = offerById.pequeño || null;
					offerData.mediano = offerById.mediano || null;
					offerData.con_Collila = offerById.con_Collila || null;
					offerData.verde = offerById.verde || null
					if (this.isChoose === true) {
						this.$router.push({
							query: {
								// ...this.$route.query,
								type: this.$route.query.type,
								purchaseId: this.$route.query.purchaseId,
								sectionTwoId: id,
								typeSectionTwo: type === 0 ? 'offer' : type === 1 ? 'purchase' : null,
								purchaseTwoSectionId: purchaseId,
							}
						}).catch(err => {
							if (err.name !== 'NavigationDuplicated') {
								throw err;
							}
						});
					}
				} else {
					console.log('goo to ')
					this.loadingPurchase = true;
					const selectPurchaseData = !this.isChoose ? this.purchaseData : this.purchaseDataCompareTwo
					return Promise.all([
						this.$store.dispatch('purchases/fetchById', {
							id: purchaseId
						}),
						this.$store.dispatch('receives/fetchById', { id: id })
					]).then(([purchaseData, receiveData]) => {
						selectPurchaseData.lot = receiveData.lot;
						selectPurchaseData.date = moment(purchaseData.date).format('YYYY-MM-DD');
						selectPurchaseData.income = purchaseData.entryNo; 
						selectPurchaseData.providerId = purchaseData.providerId;
						selectPurchaseData.price = !receiveData ? purchaseData.administrationPrice : receiveData.price;
						selectPurchaseData.priceFormat = !receiveData ? this.$options.filters.numberFormat(purchaseData.administrationPrice) : this.$options.filters.numberFormat(receiveData.price)
						selectPurchaseData.humidity = receiveData.humidity || null;
						selectPurchaseData.isSeed = purchaseData.isSeed;

						// receive data
						this.updatePurchaseEntires();
						selectPurchaseData.weight = receiveData.qqNetWeight;
						selectPurchaseData.weightFormat = this.$options.filters.numberFormat(receiveData.qqNetWeight);
						selectPurchaseData.totalPurchase = fixNumber(selectPurchaseData.weight * selectPurchaseData.price);
						selectPurchaseData.specialInvoice = receiveData.specialInvoice;
						selectPurchaseData.creditNote = receiveData.creditNote;
						selectPurchaseData.pacoReference = receiveData.pacoReference;
						selectPurchaseData.notes = receiveData.note;

						console.log('selectPurchaseData', selectPurchaseData)
						if (purchaseData.status !== 1) {
							selectPurchaseData.entires.forEach((entry, index) => {
								const item = purchaseData.items.find(c => c.itemId === entry.id);
								const parent = purchaseData.items.find(c => c.itemId === entry.parentId);
								if (item) {
									selectPurchaseData.entires[index].percent = item.percent;
									selectPurchaseData.entires[index].weight =
										fixNumber(
											(item.percent / 100) *
											(!entry.parentId ? selectPurchaseData.weight : parent.weight)
										);
								}
							})
						} else {
							selectPurchaseData.entires.forEach((entry, index) => {
								const item = receiveData.items.find(c => c.itemId === entry.id);
								const parent = receiveData.items.find(c => c.itemId === entry.parentId);
								if (item) {
									selectPurchaseData.entires[index].percent = item.percent;
									selectPurchaseData.entires[index].weight =
										fixNumber(
											(item.percent / 100) *
											(!entry.parentId ? selectPurchaseData.weight : parent?.weight)
										);
								}
							})
						}

						if (this.isChoose === true) {
							console.log('vkfgkjfkgdkgdfkgjfk')
							this.$router.push({
								query: {
									sectionTwoId: id,
									type: this.$route.query.type,
									typeSectionTwo: type === 0 ? 'offer' : type === 1 ? 'purchase' : null,
									purchaseTwoSectionId: purchaseId,
									purchaseId: this.$route.query.purchaseId
								}
							}).catch(err => {
								if (err.name !== 'NavigationDuplicated') {
									throw err;
								}
							});
							console.log('his.isChoose === true', this.isChoose === true ? this.selectedOption === 0 ? 'offer' : 'purchases' : null)
						}
					}).finally(() => {
						this.loadingPurchase = false
					});
				}
			}).finally(() => {
				this.loadingSectionTwo = false;
				this.loadingSectionOne = false
			});
		}
	},

	async created () {
		this.selectedOption = this.$route.query.type === 'offer' ? 0 : 1

		this.filter()
		if (this.$route.params.id && this.$route.query.type) {
			this.isChoose = false;
			this.loadingSectionOne = true
			try {
				this.loadingSectionOne = true
				await this.getById(
					this.$route.params.id, 
					this.selectedOption,
					this.$route.query.purchaseId ? this.$route.query.purchaseId : null
				).then(() => {
					this.loadingSectionOne = false
					if (this.$route.query.sectionTwoId || this.$route.query.typeSectionTwo || this.$route.query.purchaseTwoSectionId) {
						this.loadingSectionTwo = true
						this.isChoose = true
						this.getById(
							this.$route.query.sectionTwoId, 
							this.$route.query.typeSectionTwo === 'offer' ? 0 : this.$route.query.typeSectionTwo === 'purchase' ? 1 : null, 
							this.$route.query.purchaseTwoSectionId 
								? this.$route.query.purchaseTwoSectionId 
								: null, 
							this.loadingSectionTwo
						).then(() => {
							this.loadingSectionTwo = false
						}).catch(() => {
							this.loadingSectionTwo = false
						})
					}
				}).catch(() => {
					this.loadingSectionOne = false
				})
			} catch (e) {
				console.error(e)
			}
		}
	}
})
</script>

<style scoped>
.bgGreenLight {
	background-color: #c1dfca45
}
</style>
